import { Tooltip } from 'antd'
import { ReactNode, useEffect, useRef, useState } from 'react'

const MESSAGE = 'Срок доставки указан в рабочих днях, без учета выходных.'

type DeliveryTimeHintProps = {
  className: string
  children: ReactNode
}

function DeliveryTimeHint({ className, children }: DeliveryTimeHintProps) {
  const [open, setOpen] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!open) return

    const close = () => setOpen(false)
    const closeOnOutsideClick = (event: MouseEvent) => {
      if (!triggerRef.current?.contains(event.target as Node)) close()
    }

    document.addEventListener('mousedown', closeOnOutsideClick)
    window.addEventListener('scroll', close, true)
    window.addEventListener('wheel', close, { passive: true })
    window.addEventListener('touchmove', close, { passive: true })

    return () => {
      document.removeEventListener('mousedown', closeOnOutsideClick)
      window.removeEventListener('scroll', close, true)
      window.removeEventListener('wheel', close)
      window.removeEventListener('touchmove', close)
    }
  }, [open])

  return (
    <Tooltip title={MESSAGE} trigger="click" open={open} onOpenChange={setOpen}>
      <button
        ref={triggerRef}
        type="button"
        className={className}
        data-open={open || undefined}
      >
        {children}
      </button>
    </Tooltip>
  )
}

export default DeliveryTimeHint
